export default "__VITE_ASSET__6d508ac4__"